module.exports = __webpack_public_path__ + "videos/careers_16x9.f3e9876.mp4";